import request from '@/utils/request'

export function updateAvatarCfg(data) {
  return request({
    url: 'api/v1/avatar/updateCfg',
    method: 'post',
    data: data
  })
}

export function getAvatarCfgList(data) {
  return request({
    url: 'api/v1/avatar/getList',
    method: 'post',
    data: data
  })
}

export function getAvatarCfgAll(data) {
  return request({
    url: 'api/v1/avatar/getListAll',
    method: 'post',
    data: data
  })
}

export function delAvatarCfg(data) {
  return request({
    url: 'api/v1/avatar/delBaseCfg',
    method: 'delete',
    data: data
  })
}

